// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71f32490","239":"7309a5ad","455":"8b30e8f3"}[chunkId] + ".chunk.js";
};